"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaceholderWrapper = exports.Image = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Image = exports.Image = _styledComponents["default"].img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  height: ", ";\n  width: ", ";\n  object-fit: cover;\n  aspect-ratio: 1;\n  max-width: none;\n  border: var(--border-width-hairline) solid var(--color-neutral-100);\n\n  ", "\n"])), function (_ref) {
  var imageSize = _ref.imageSize;
  return imageSize === 'large' ? 'var(--border-radius-md)' : 'var(--border-radius-sm)';
}, function (_ref2) {
  var imageSize = _ref2.imageSize;
  return imageSize === 'large' ? '72px' : '44px';
}, function (_ref3) {
  var imageSize = _ref3.imageSize;
  return imageSize === 'large' ? '72px' : '44px';
}, function (_ref4) {
  var adStatus = _ref4.adStatus;
  return adStatus !== 'active' && adStatus !== 'active_sold' && "\n    opacity: 0.4;\n  ";
});
var PlaceholderWrapper = exports.PlaceholderWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--color-neutral-90);\n  border-style: solid;\n  border-radius: ", ";\n  border-width: var(--border-width-hairline);\n  border-color: var(--color-neutral-100);\n  padding: ", ";\n"])), function (_ref5) {
  var imageSize = _ref5.imageSize;
  return imageSize === 'large' ? '72px' : '44px';
}, function (_ref6) {
  var imageSize = _ref6.imageSize;
  return imageSize === 'large' ? '72px' : '44px';
}, function (_ref7) {
  var imageSize = _ref7.imageSize;
  return imageSize === 'large' ? 'var(--border-radius-md)' : 'var(--border-radius-sm)';
}, function (_ref8) {
  var imageSize = _ref8.imageSize;
  return imageSize === 'large' ? '0 21px' : '0 16px';
});